import { render, staticRenderFns } from "./DeviceDetailsV2.vue?vue&type=template&id=f1f2475c&"
import script from "./DeviceDetailsV2.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports